if (!customElements.get('purchase-unit-pricing')) {
  customElements.define(
    'purchase-unit-pricing',
    class PurchaseUnitPricing extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('[data-purchase-unit-messages]');
        const output = this.querySelector('[data-purchase-unit-message]');
        if (!data || !output) return;

        try {
          this.messages = JSON.parse(data.textContent);
        } catch (_error) {
          this.messages = {};
        }

        this.output = output;
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (String(event.data.sectionId) !== String(this.dataset.sectionId)) return;
          this.updateMessage(event.data.variant?.id);
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      updateMessage(variantId) {
        const message = this.messages[String(variantId)] || '';
        this.output.textContent = message;
        this.hidden = message === '';
        this.dataset.variantId = variantId || '';
      }
    }
  );
}
